import { NamedDefinitionPage } from './NamedDefinitionPage';

export function SalesManagersPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/salesmanagers"
      listRoute="/sales-managers"
      title="Satış Müdürü"
      subtitle="Satış müdürü kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Kod"
      descriptionLabel="Açıklama"
      descRequired
      newLabel="Yeni Satış Müdürü"
      exportName="satis-mudurleri"
      entityLabel="satış müdürü"
    />
  );
}
